"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "AdminTool_"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21,6V4.5A2.5,2.5,0,0,0,18.5,2H2.5A2.5,2.5,0,0,0,0,4.5V6H21ZM3.5,5A.5.5,0,1,1,4,4.5.5.5,0,0,1,3.5,5Zm2,0A.5.5,0,1,1,6,4.5.5.5,0,0,1,5.5,5Zm2,0A.5.5,0,1,1,8,4.5.5.5,0,0,1,7.5,5Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21,15.5V7H0v8.5A2.5,2.5,0,0,0,2.5,18h16A2.5,2.5,0,0,0,21,15.5Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22,11v4.5A3.5,3.5,0,0,1,18.5,19H3v.5A2.5,2.5,0,0,0,5.5,22h16A2.5,2.5,0,0,0,24,19.5V11Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,10V8.5a2.5,2.5,0,0,0-2-2.45v4Z",
    fill: "#024965"
  }), ' ');
};

exports["default"] = _default;